import { FC, ReactNode, useEffect } from "react";
import { useAuthUserState } from "../context/authUser.context";
import { useInstituteContext } from "../context/institute.context";
import { isInstituteScopedUser } from "../utils/userTypes";

/**
 * Component that handles automatic institute assignment for restricted users
 * Must be rendered inside both AuthUserProvider and InstituteProvider
 */
export const InstituteAssignmentHandler: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const { userDetails } = useAuthUserState();
  const { setSelectedInstitute } = useInstituteContext();

  useEffect(() => {
    if (
      userDetails &&
      isInstituteScopedUser(userDetails) &&
      userDetails.assignedInstitute
    ) {
      setSelectedInstitute(userDetails.assignedInstitute);
    }
  }, [userDetails, setSelectedInstitute]);

  return <>{children}</>;
};
